import { Component, OnInit } from '@angular/core';
import { SimpleModalComponent } from "ngx-simple-modal";

export interface ConfirmModel {
  title:string;
  message:string;
}
@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent extends SimpleModalComponent<ConfirmModel, boolean> implements ConfirmModel, OnInit {
  title: string;
  message: string;

  ngOnInit(): void {
    this.addIubendaScript();
  }

  confirm() {
    // we set modal result as true on click on confirm button,
    // then we can get modal result from caller code
    this.result = true;
    this.close();
  }

  private addIubendaScript() {
    (function (w,d) {
      var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; 
      s.src="https://cdn.iubenda.com/iubenda.js"; 
      tag.parentNode.insertBefore(s,tag);
    })(window, document);
  
  }

}